import type { AxiosRequestConfig, GenericAbortSignal } from 'axios'
import { API_VACANCY_URL } from '../constants/base-urls'
import type {
  IJobRequisitionDetailRequest,
  IJobRequisitionRequest,
  IPaginationParam,
  IPaginationResponse,
  IStatistic,
  IVacancy,
  IVacancyRequest,
} from '../types'
import { createAxiosInstance } from '../utils'

type FetchVacanciesParams = {
  departmentIds?: string
  organizationIds?: string
  vacancyId?: string
  candidateId?: string
  isRequisition?: 0 | 1
  status?: string
  flag?: string
} & IPaginationParam

const axios = createAxiosInstance({
  baseURL: API_VACANCY_URL,
  withAuth: true,
})

export const fetchVacanciesNotApplied = (params?: FetchVacanciesParams, signal?: GenericAbortSignal) => {
  const candidateId = params?.candidateId
  const name = params?.q
  return axios
    .get<{ data: IPaginationResponse<IVacancy> }>(`applicant/vacancy/${candidateId}`, {
      params: {
        name: name,
      },
      signal: signal,
    })
    .then((response) => response.data.data)
}
export const fetchVacancies = (params?: FetchVacanciesParams, signal?: GenericAbortSignal) => {
  return axios
    .get<{ data: IPaginationResponse<IVacancy> }>(`/vacancy`, {
      params: {
        ...params,
        status: params?.status ?? 'all',
      },
      signal: signal,
    })
    .then((response) => response.data.data)
}

export const fetchVacancyDetail = (id: string, config?: AxiosRequestConfig) => {
  return axios.get<{ data: IVacancy }>(`/vacancy/${id}`, config).then((response) => response.data.data)
}

export const createVacancy = (payload: Partial<IVacancyRequest> | IJobRequisitionRequest) => {
  console.log(payload)
  return axios.post<{ data: IVacancy }>(`/vacancy`, payload).then((response) => response.data.data)
}

export const getLastVacancyNumber = () => {
  return axios.get<{ data: string }>('/vacancy/vacancy-number').then((response) => response.data.data)
}
export const udpateVacancy = (id: string, payload: Partial<IVacancyRequest> | IJobRequisitionDetailRequest) => {
  return axios.put<{ data: IVacancy }>(`/vacancy/${id}`, payload).then((response) => response.data.data)
}

export const deleteDraftVacancy = (id: string) => {
  return axios.delete(`/vacancy/${id}`).then((response) => response.data.data)
}

export const updateVacancyStatus = (id: string, status: 'active' | 'draft' | 'inactive', payload?: Record<string, any>) => {
  return axios.patch(`/vacancy/${id}`, { ...payload, status }).then((response) => response.data.data)
}

export const cancelRequisition = (id: string, config?: AxiosRequestConfig) => {
  return axios.patch(`/vacancy/requisition/cancel/${id}`, config).then((response) => response.data.data)
}

export const fetchTotalRequisition = () => {
  return axios.get<{ data: any }>(`/vacancy/total-requisition`).then((response) => response.data.data)
}

// export const exportToExcel = () => {
//   return axios
//     .get(`/vacancy/requisition/excel-export?isRequisition=1`, {
//       responseType: 'blob',
//       headers: {
//         Accept: 'application/octet-stream',
//       },
//     })
//     .then((response) => response.data)
// }

// export const exportToPDF = () => {
//   return axios
//     .get(`/vacancy/requisition/pdf-export?isRequisition=1`, {
//       responseType: 'arraybuffer',
//       headers: {
//         Accept: 'application/pdf',
//       },
//     })
//     .then((response) => response.data)
// }

export const exportToExcel = (params?: { search?: string; flag?: string }) => {
  const queryParams = new URLSearchParams({
    isRequisition: '1',
  })

  if (params?.search) {
    queryParams.append('q', params.search)
  }

  if (params?.flag) {
    queryParams.append('flag', params.flag)
  }

  return axios
    .get(`/vacancy/requisition/excel-export?${queryParams.toString()}`, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => response.data)
}

export const exportToPDF = (params?: { search?: string; flag?: string }) => {
  const queryParams = new URLSearchParams({
    isRequisition: '1',
  })

  if (params?.search) {
    queryParams.append('q', params.search)
  }

  if (params?.flag) {
    queryParams.append('flag', params.flag)
  }

  return axios
    .get(`/vacancy/requisition/pdf-export?${queryParams.toString()}`, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/pdf',
      },
    })
    .then((response) => response.data)
}

export const updateRequisitionStatus = (
  id: string,
  status: 'reject' | 'approve' | 'cancel' | 'publish' | 'progress',
  payload?: Record<string, any>,
  config?: AxiosRequestConfig,
) => {
  return axios.patch(`/requisition/${id}`, { ...payload, status }, config).then((response) => response.data.data)
}

export const sendReminder = (id: string) => {
  return axios.post(`/requisition/${id}/send-reminder`).then((response) => response.data.data)
}

export const fetchVacancyStatistic = (params?: { isRequisition: '1' | '0' }) => {
  return axios.get<{ data: IStatistic[] }>(`/statistics`, { params }).then((response) => response.data.data)
}

export const fetchVacancyRRNumber = () => {
  return axios.get<{ data: string }>(`/requisition/rr-number`).then((response) => response.data.data)
}
